import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { GET_ALL_PRODUCTS } from "../../api/endpoints";
import openNotification from "../../components/Common/OpenNotification";
const initialState = {
    products: [],
    productTypes: [],
    loading: false,
    error: null,
    totalPagesProducts: 0,
};

export const fetchProducts = createAsyncThunk(
    "product/fetchProducts",
    async ({ page, pageSize, headType, unitCode, search }= {}, { rejectWithValue }) => {
        try {
            const params = {};
            if (page) params.page = page;
            if (pageSize) params.limit = pageSize;
            if(headType) params.headType = headType; // Add headType to params if provided
            if(unitCode) params.UNIT_CODE = unitCode;
            if(search) params.search = search;

            const response = await axiosInstance.get(
                `${GET_ALL_PRODUCTS}`,
                {
                    params,
                }
            );

            return response.data;
        } catch (error) {
            openNotification(
                error?.response?.data?.message || "Something went wrong."
            );
            return rejectWithValue(
                error?.response?.data?.message || "Something went wrong."
            );
        }
    }
);

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(fetchProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                // console.log("product action payload",action.payload);
                state.loading = false;
                state.products = action.payload.data.data;
                state.totalPagesProducts = action?.payload?.data?.total;
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

    },
});
export default productSlice.reducer;

